<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <i class="uil-home-alt"></i>
            </router-link>
          </li>
          <li>{{ this.$t('menu.company_dashboard.advertisement') }}</li>
          <li>{{ this.$t('general.banner_list') }}</li>
        </ul>
      </nav>
    </div>
    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ this.$t('general.banner_list') }} </span>
        </h2>
      </div>
      <div class="section-header-right">
        <router-link :to="{ name: 'company.advertisement.add' }" class="btn btn-default">
          <i class="uil-plus"></i> {{ $t('general.add_ads') }}
        </router-link>
      </div>
    </div>

    <template v-if="errorMessages">
      <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: red">
          <i class="uil-exclamation-triangle"></i> {{ error }}
        </p>
      </div>
    </template>
    <div v-if="successMessage" class="uk-alert-success" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color: green">
        <i class="uil-exclamation-triangle"></i> {{ successMessage }}
      </p>
    </div>
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <!-- <h4 class="d-inline-block mb-0"></h4> -->
          <!-- <div>
              <a href="#" class="btn btn-icon btn-hover btn-circle" aria-expanded="false">
                <i class="uil-search"></i>
              </a>
              <div class="uk-drop" uk-drop="mode: hover; pos: right-center; offset: 0" style="left: 91px; top: 159.297px;">
                <form class="uk-search uk-search-navbar uk-width-1-1">
                  <input class="uk-search-input shadow-0 uk-form-small" type="search" :placeholder="$t('general.search')" autofocus="" v-model="filter.search">
                </form>
              </div>
            </div> -->
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')"
                     class="uk-search-input shadow-0 uk-form-small"
                     type="search"/>
            </div>
          </div>
          <div class="d-flex">
            <!-- Shorting -->
            <a :uk-tooltip="$t('filters.sort_list')" aria-expanded="false" class="btn btn-icon btn-hover  btn-circle"
               href="#"
               title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li @click="sortOrder('name', 'asc')">
                  <a href="javascript:void(0)">{{ $t("sorting.a_z") }}</a>
                </li>
                <li @click="sortOrder('name', 'desc')">
                  <a href="javascript:void(0)">{{ $t("sorting.z_a") }}</a>
                </li>
                <li @click="sortOrder('created_at', 'asc')">
                  <a href="javascript:void(0)">
                    {{ $t("sorting.created_at_asc") }}</a>
                </li>
                <li @click="sortOrder('created_at', 'desc')">
                  <a href="javascript:void(0)">
                    {{ $t("sorting.created_at_desc") }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Table -->
      <div class="sortable-table">
        <ul class="list-group draggable-list-group">
          <li class="list-group-item font-weight-bold d-flex justify-content-between align-items-center">
            <span class="column">{{ this.$t('general.heading') }}</span>
            <span class="column">{{ this.$t('general.connection') }}</span>
            <span class="column">{{ this.$t('general.added_date') }}</span>
            <span class="column">{{ this.$t('general.status') }}</span>
            <span class="column"></span>
          </li>
        </ul>
        <ul ref="sortableList" class="list-group draggable-list-group" uk-sortable="handle: .draggable-list"
            @stop="onDragEnd">
          <li v-for="(item, index) in formattedItems" :key="'advertisement_list_item_' + index" :data-id="item.id"
              class="draggable-list list-group-item d-flex justify-content-between align-items-center">

            <div class="media align-items-center column">
              <i class="uil uil-bars mr-4"></i>
              <div class="avatar-parent-child" style="width: max-content">
                <img :src="item.image_link" alt="Image" class="avatar-img"/>
              </div>
              <div class="media-body ml-4">
                <a class="name h6 mb-0 text-sm" href="#">{{ item.name }}</a>
                <small class="d-block font-weight-bold">#{{ item.id }}</small>
              </div>
            </div>
            <span class="column">{{ item.url }}</span>
            <span class="column"><i class="uil-calendar-alt"></i> {{ item.created_at }}</span>
            <span class="column"><i class="uil-check"></i> {{ item.status }}</span>
            <div class="column actions ml-3">
              <router-link :to="{ name: 'company.advertisement.edit', params: { id: item.id } }"
                           :uk-tooltip="$t('faq_categories.edit')" class="btn btn-icon btn-hover btn-sm btn-circle">
                <i class="uil-edit"></i>
              </router-link>
              <a aria-expanded="false" class="btn btn-icon btn-hover btn-sm btn-circle text-danger"
                 href="javascript:void(0)"
                 :uk-tooltip="$t('general.delete')" @click="removeItem(item.id)">
                <i class="uil-minus-circle"></i>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/core/services";
import moment from "moment";
import module, {
  BASE_URL,
  MODULE_NAME,
  DELETE_ITEM,
  ITEMS,
  GET_ITEMS,
  ERROR,
} from "@/core/services/store/advertisement.module";
import Pagination from "@/assets/components/Pagination";
import {confirmDialogDelete} from "@/utils/confirmDialog";

export default {
  name: "AdvertisementList",
  components: {Pagination},
  data() {
    return {
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      filter: {
        search: null,
        order: "asc",
        sort: "order",
      },
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(MODULE_NAME, module);
  },
  computed: {
    items: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEMS];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    formattedItems() {
      let results = [];
      if (this.items === null || !("data" in this.items)) return [];
      this.pagination = this.items;
      this.items.data.forEach((currentItem) => {
        results.push({
          id: currentItem.id,
          name: currentItem.name,
          url: currentItem.url,
          text: currentItem.text ? currentItem.text : "-",
          image_link: currentItem.image_link,
          status: currentItem.status_id
              ? this.$t("general.active")
              : this.$t("general.passive"),
          created_at: currentItem.created_at
              ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
        });
      });
      return results;
    },
  },
  methods: {
    getResult() {
      let self = this;
      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: BASE_URL,
        filters: {
          like: self.filter.search,
          page: self.page,
          per_page: self.per_page,
          sort: self.filter.sort,
          order: self.filter.order,
        },
      });
    },

    async onDragEnd() {
      const items = this.$refs.sortableList.querySelectorAll('.draggable-list');
      const newOrder = Array.from(items).map((el, index) => ({id: el.getAttribute('data-id'), order: index}));

      try {
        await axios.post('/api/advertisement/update-order', {items: newOrder}
        ).then(() => {
          this.successMessage = this.$t("general.update_success");
        })
      } catch (error) {
        this.errorMessages.push(this.$t('errors.500'))
      }
    },
    async removeItem(id) {
      const isConfirmed = await confirmDialogDelete({context: this});
      if (isConfirmed) {
        this.$store
            .dispatch(MODULE_NAME + "/" + DELETE_ITEM, {
              url: BASE_URL + "/" + id,
            })
            .then(() => {
              if (!this.error) {
                this.successMessage = this.$t("general.successfully_deleted");
                this.getResult();
              } else this.errorMessages.push(this.error);
          });
      }
    },
    sortOrder(sort, order) {
      let self = this;
      self.page = 1;
      self.filter.sort = sort;
      self.filter.order = order;

      this.getResult();
    },
    setPage(page) {
      let self = this;
      self.page = page;
      this.getResult();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  mounted() {
    this.getResult();
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.getResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>

<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.avatar-img {
  height: 25px;
  width: 50px;
  object-fit: cover !important;
  border-radius: 8px;
}

.draggable-list {
  cursor: grab;
}

.media i {
  font-size: 1.25rem;
}

ul.draggable-list-group {
  display: table;
  width: 100%;
}

ul.draggable-list-group li {
  display: table-row
}

ul.draggable-list-group li .column {
  width: 20%;
  padding: .5rem;
}

ul.draggable-list-group li .column:first-child {
  width: 40%;
}

ul.draggable-list-group li .column:last-child {
  width: 10%;
}

</style>
